import authHeader from "../../../../authentication/authservices/auth-header";

import apiClient from "../../../../http-common"

//Patient Info
export const getPatient = (patientId, visitId, visitNumber) => {
  return apiClient.get(
    `/opd/patientemr/getPatientInfoForEmr?patientId=${patientId}&visitId=${visitId}&visitNumber=${visitNumber}`,
    {
      headers: authHeader(),
    }
  );
};

//Vital
//Vital Charts Data
export const getChartDetails = (patientId) => {
  return apiClient.get(
    `/ipd/patientassessment/getPatientVitalsChart?patientId=${patientId}`,
    {
      headers: authHeader(),
    }
  );
};

//Complaints
//Complaint List
export const getComplaints = (searchkey) => {
  return apiClient.get(`/masters/complaints/search/${searchkey}`, {
    headers: authHeader(),
  });
};

//Documents
//Document Types
export const getDocumentType = () => {
  return apiClient.get(`/masters/documenttype/dropdown`, {
    headers: authHeader(),
  });
};

//Diagnosis
//ICD code List
export const getICDCode = (departmentId, searchkey) => {
  return apiClient.get(
    `/masters/icdCode/search?departmentId=${departmentId}&searchString=${searchkey}`,
    {
      headers: authHeader(),
    }
  );
};

//Surgery Details
//Surgery List
export const getSurgeryList = (departmentId, searchkey) => {
  return apiClient.get(
    `/masters/surgerydetails/searchForEmr?departmentId=${departmentId}&searchString=${searchkey}`,
    {
      headers: authHeader(),
    }
  );
};

//Allergies
//Allergies Types
export const getAllergies = (searchkey) => {
  return apiClient.get(`/masters/allergy/search/${searchkey}`, {
    headers: authHeader(),
  });
};

//Investigation
//Test Type
export const getTestType = () => {
  return apiClient.get(`/masters/tests/testtypedropdown`, {
    headers: authHeader(),
  });
};

//Investigation Dropdown List
export const getInvestigationListTemplate = (searchString, testId) => {
  return apiClient.get(`/masters/tests/search/${searchString}/${testId}`, {
    headers: authHeader(),
  });
};
export const getInvestigationList = (investigationObj) => {
  return apiClient.get(
    `/masters/tests/opdinvestigations?departmentId=${investigationObj.departmentId}&searchString=${investigationObj.searchString}&testTypeId=${investigationObj.testTypeId}&unitId=${investigationObj.unitId}`,
    {
      headers: authHeader(),
    }
  );
};

export const getInvestigationListCardiology = (searchString, unitid) => {
  return apiClient.get(
    `/tests/searchAllInvestigations/${searchString}/${unitid}`,
    {
      headers: authHeader(),
    }
  );
};
// Symptoms
//Symptoms List
export const getSymptoms = (searchkey) => {
  return apiClient.get(`/masters/symptoms/search/${searchkey}`, {
    headers: authHeader(),
  });
};

//Services
export const getService = (searchkey, unitId, departmentId, doctorId) => {
  return apiClient.get(
    `/masters/services/searchOpdServices?departmentId=${departmentId}&doctorId=${doctorId}&searchString=${searchkey}&unitId=${unitId}`,
    {
      headers: authHeader(),
    }
  );
};

//Prescription
//Drug Name List
export const getDrugName = (type, searchkey) => {
  return apiClient.get(
    `/masters/item/searchdrugsforprescription/${type}/${searchkey}`,
    {
      headers: authHeader(),
    }
  );
};

//Instruction List
export const getInstruction = (searchkey) => {
  return apiClient.get(`/masters/instructions/search/${searchkey}`, {
    headers: authHeader(),
  });
};

//Frequency List
export const getFrequency = () => {
  return apiClient.get(`/masters/frequency/dropdown`, {
    headers: authHeader(),
  });
};

//Doses
export const getDoses = () => {
  return apiClient.get(`/masters/dose/dropdown`, { headers: authHeader() });
};

//Route List
export const getRoute = () => {
  return apiClient.get(`/masters/route/dropdown`, {
    headers: authHeader(),
  });
};

//Department
export const getDepartment = () => {
  return apiClient.get(`/masters/departments/dropdown/1`, {
    headers: authHeader(),
  });
};

export const getDepartmentSearch = (unitId) => {
  return apiClient.get(
    `/masters/departments/departmentDropDownUnitWiseWeekDayWise/${unitId}/false`,
    {
      headers: authHeader(),
    }
  );
};

//Doctors List
export const getDoctors = (departmentId) => {
  return apiClient.get(`/masters/employees/dropdown/${departmentId}`, {
    headers: authHeader(),
  });
};
//Doctors List
export const getSurgeon = () => {
  return apiClient.get(`/masters/employees/surgeonDropdown`, {
    headers: authHeader(),
  });
};

//Copy Prescription
export const copyPrescription = (patientId) => {
  return apiClient.get(
    `/opd/patientemr/getPreviousPrescription?patientId=${patientId}`,
    {
      headers: authHeader(),
    }
  );
};

//POST EMR Data
export const saveEMRData = async (template, details) => {
  // console.log(departmentId);
  if (template !== undefined) {
    return await apiClient.post(`/patientemr?template=${template}`, details, {
      headers: authHeader(),
    });
  } else if (template === undefined) {
    return await apiClient.post(`/patientemr`, details, {
      headers: authHeader(),
    });
  }
};

//Get EMR Details Based of Patient Info Id
export const getPatientInfoById = async (patientInfoId) => {
  return await apiClient.post(
    `/opd/patientemr/getPatientAssessmentDetails`,
    patientInfoId,
    {
      headers: authHeader(),
    }
  );
};

//Get  Details Based on Visit Number
export const getDetailsByVisitNumber = async (visitNumber) => {
  return await apiClient.post(
    `/opd/patientemr/getPatientAssessmentDetails`,
    visitNumber,
    {
      headers: authHeader(),
    }
  );
};

export const getAllInstigations = (visitId) => {
  return apiClient.get(
    `/reports/generatePdf/labreports?patientVisitId=${visitId}`,
    { headers: authHeader(), responseType: "blob" }
  );
};

export const getInstigationById = (visitId, investigationId) => {
  return apiClient.get(
    `/reports/generatePdf/labreports?patientVisitId=${visitId}&investigationId=${investigationId}`,
    { headers: authHeader(), responseType: "blob" }
  );
};

// Chips for Allergies
export const getAllergiesChips = () => {
  return apiClient.get(`/masters/allergy/getAllergies`, {
    headers: authHeader(),
  });
};
// Chips for Compalints
export const getComplaintsChips = () => {
  return apiClient.get(`/masters/complaints/getComplaints`, {
    headers: authHeader(),
  });
};
//Chips for Symptoms
export const getSymptomsChips = () => {
  return apiClient.get(`/masters/symptoms/getSymptoms`, {
    headers: authHeader(),
  });
};
//Chips for Pathology
export const getPathologyChips = (unitId) => {
  return apiClient.get(
    `/masters/tests/getCommonInvestigations/Pathology/${unitId}/0`,
    {
      headers: authHeader(),
    }
  );
};

//Chips for Frequency
export const getFrequencyChips = (unitId) => {
  return apiClient.get(`/masters/frequency/getCommonFrequency`, {
    headers: authHeader(),
  });
};
//Chips for Instruction
export const getInstructionChips = (unitId) => {
  return apiClient.get(`/masters/instructions/getCommonInstruction`, {
    headers: authHeader(),
  });
};
//Chips for Route
export const getRouteChips = (unitId) => {
  return apiClient.get(`/masters/route/getCommonRoute`, {
    headers: authHeader(),
  });
};

//Chips for Advice
export const getAdvice = (departmentId, doctorId, searchKey) => {
  return apiClient.get(
    `/masters/advice/search?departmentId=${departmentId}&doctorId=${doctorId}&searchString=${searchKey}`,
    {
      headers: authHeader(),
    }
  );
};
//Chips for Diagnosis
export const getDiagnosis = (departmentId, doctorId) => {
  return apiClient.get(
    `/masters/icdCode/getCommonIcdCode?departmentId=${departmentId}&doctorId=${doctorId}`,
    {
      headers: authHeader(),
    }
  );
};
//General Instruction
export const getGeneralInstruction = (searchKey) => {
  return apiClient.get(
    `/masters/generalInstruction?searchString=${searchKey}`,
    {
      headers: authHeader(),
    }
  );
};

export const getDocumentsImage = (imgPath) => {
  return apiClient.get(`/masters/file${imgPath}`, {
    headers: authHeader(),
    responseType: "arraybuffer",
  });
};

//Alernative Medication Services

export const getSearchedDrugList = (
  searchKey,
  prescriptionType,
  storeId,
  unitId
) => {
  return apiClient.get(
    `/masters/item/searchdrugsforpharmacy/${prescriptionType}/${searchKey}/${storeId}/${unitId}`,
    {
      headers: authHeader(),
    }
  );
};
export const getAlternativeDrugList = (selectedDrugId) => {
  return apiClient.get(`/masters/item/getdrugsbygenericid/${selectedDrugId}`, {
    headers: authHeader(),
  });
};

export const generalInstractionGynac = (
  departmentId,
  doctorId,
  searchString
) => {
  return apiClient.get(
    `/masters/generalInstruction?departmentId=${departmentId}&doctorId=${doctorId}&searchString=${searchString}`,
    {
      headers: authHeader(),
    }
  );
};
export const generalInstractionGynacTemplate = (searchString) => {
  return apiClient.get(
    `/masters/generalInstruction?searchString=${searchString}`,
    {
      headers: authHeader(),
    }
  );
};
export const getICDCodeSerachBy = (departmentId, doctorId, searchString) => {
  return apiClient.get(
    `/masters/icdCode/search?departmentId=${departmentId}&doctorId=${doctorId}&searchString=${searchString}`,
    {
      headers: authHeader(),
    }
  );
};
export const getICDCodeSerachByTemplate = (searchString) => {
  return apiClient.get(`/masters/icdCode/search?searchString=${searchString}`, {
    headers: authHeader(),
  });
};
export const getDepartmentByUnitId = (unitId) => {
  return apiClient.get(`/departments/departmentdropdown/${unitId}`, {
    headers: authHeader(),
  });
};
export const getInvestigation = (departmentId, searchString, testTypeId) => {
  return apiClient.get(
    `/masters/tests/opdinvestigations?departmentId=${departmentId}&searchString=${searchString}&testTypeId=${testTypeId}`,
    {
      headers: authHeader(),
    }
  );
};
export const getDrugList = (type, searchString) => {
  return apiClient.get(
    `/masters/item/searchdrugsforprescription/${type}/${searchString}`,
    {
      headers: authHeader(),
    }
  );
};

// /opd/patientemr/retrievePatientDocuments

export const getDocumentPath = (obj) => {
  return apiClient.post(`/opd/patientemr/retrievePatientDocuments`, obj, {
    headers: authHeader(),
  });
};

export const getDocument = () => {
  return apiClient.get(
    `/masters/documentTypeMrd/clinicalDocumentTypeDropdown`,
    {
      headers: authHeader(),
    }
  );
};

export const getCasePaper = (patientId, employeeId) => {
  return apiClient.get(
    `/generatePdf/caseSummary?patientVisitId=${patientId}&employeeId=${employeeId}`,
    {
      headers: authHeader(),
      responseType: "blob",
    }
  );
};

export const GetPathologyDocument = (obj) => {
  return apiClient.post(`/generatePdf/pathologylabreports`, obj, {
    headers: authHeader(),
    responseType: "blob",
  });
};

export const GetRadiologyDocument = (obj) => {
  return apiClient.post(`/generatePdf/pathologylabreports`, obj, {
    headers: authHeader(),
    responseType: "blob",
  });
};

export const getCoMorbid = () => {
  return apiClient.get(`/comorbid/dropdown`, {
    headers: authHeader(),
  });
};

export const getPatientVisitLisit = (patientId, unitId) => {
  return apiClient.get(`/patientemr/getPatientVisits/${patientId}/${unitId}`, {
    headers: authHeader(),
  });
};

export const getVaccineChart = (patientId) => {
  return apiClient.get(`/patientemr/getPatientImmunisation/${patientId}`, {
    headers: authHeader(),
  });
};

export const prescription = (obj) => {
  return apiClient.post(`/patientemr/searchDrugForPrescription`, obj, {
    headers: authHeader(),
  });
};

export const getGenaricTable = (genericId, itemId) => {
  return apiClient.get(
    `/patientemr/searchDrugsByGenericsForPrescription/${genericId}/${itemId}`,
    {
      headers: authHeader(),
    }
  );
};

export const getPrescription = (visitId, preview, employeeId) => {
  return apiClient.get(
    `/generatePdf/prescription?visitId=${visitId}&employeeId=${employeeId}&preview=${preview}`,
    {
      headers: authHeader(),
      responseType: preview === false ? "arraybuffer" : "blob",
    }
  );
};

export const getPrescriptionPrint = (printObj) => {
  return apiClient.post(`/printerDevices/print`, printObj, {
    headers: authHeader(),
  });
};

export const getItemVaccine = (serachString) => {
  return apiClient.get(`/item/searchVaccines/${serachString}`, {
    headers: authHeader(),
  });
};

export const getPastMedication = (patientId) => {
  return apiClient.get(
    `/patientemr/getPreviousPrescription?patientId=${patientId}`,
    {
      headers: authHeader(),
    }
  );
};

export const deleteMedication = (patientId) => {
  return apiClient.delete(`/patientemr/deleteDrugFromMedication/${patientId}`, {
    headers: authHeader(),
  });
};

export const saveTeamplateCreation = (obj) => {
  return apiClient.post(`/template`, obj, {
    headers: authHeader(),
  });
};

export const templateSearch = (serachString, unitId) => {
  return apiClient.get(`/template/searchTemplate/${serachString}/${unitId}`, {
    headers: authHeader(),
  });
};

export const getTemplate = (unitId) => {
  return apiClient.get(`/template/getDoctorTemplates/${unitId}`, {
    headers: authHeader(),
  });
};

export const getTemplateData = (templateId) => {
  return apiClient.get(`/template/getTemplateDetails/${templateId}`, {
    headers: authHeader(),
  });
};

export const getTemplateMultipleData = (obj) => {
  return apiClient.post(`/template/getMultipleTemplateDetails`, obj, {
    headers: authHeader(),
  });
};
export const saveMarkFavorite = (obj) => {
  return apiClient.post(`/patientemr/markAsFavourite`, obj, {
    headers: authHeader(),
  });
};

export const getMarkFavorite = () => {
  return apiClient.get(`/patientemr/getFavourites`, {
    headers: authHeader(),
  });
};

export const DeleteService = (billInfoId) => {
  return apiClient.delete(`patientemr/deleteDrugFromMedication/${billInfoId}`, {
    headers: authHeader(),
  });
};

export const prescriptionPreview = (obj) => {
  return apiClient.post(`/generatePdf/prescriptionPreview`, obj, {
    headers: authHeader(),
    responseType: "blob",
  });
};

export const saveVaccine = (visitId, patientId, obj) => {
  return apiClient.post(
    `/patientemr/savePatientImmunisation/${visitId}/${patientId}`,
    obj,
    {
      headers: authHeader(),
    }
  );
};
// /item/searchVaccines/${visitId}

export const getSearchVaccine = (searchString) => {
  return apiClient.get(`/item/searchVaccines/${searchString}`, {
    headers: authHeader(),
  });
};

export const getServiceUtilizedList = (visitId) => {
  return apiClient.get(`/bill/packageUtilization?visitId=${visitId}`, {
    headers: authHeader(),
  });
};

export const getServiceUtilizedListData = (visitId, packageId) => {
  return apiClient.get(
    `/bill/packageUtilizationDetails?visitId=${visitId}&packageId=${packageId}`,
    {
      headers: authHeader(),
    }
  );
};

export const searchDrugForPrescription = async (postObj) => {
  return await apiClient.post(`/patientemr/searchDrugForPrescription`, postObj, {
    headers: authHeader(),
  });
};

export const getDefaultServiceCardiology = (type, id) => {
  return apiClient.get(
    `/tests/getDefaultInvestigationsByTestType/${type}/${id}`,
    {
      headers: authHeader(),
    }
  );
};

export const SaveCardiology = async (template, details) => {
  // console.log(departmentId);
  if (template !== undefined) {
    return await apiClient.post(
      `/patientemr/savePatientEmrCardiology?template=${template}`,
      details,
      {
        headers: authHeader(),
      }
    );
  } else if (template === undefined) {
    return await apiClient.post(`/patientemr/savePatientEmrCardiology`, details, {
      headers: authHeader(),
    });
  }
};

export const getUserAction = async (id) => {
  return apiClient.get(`/user-service/auth/getUserActions/${id}`, {
    headers: authHeader(),
  });
};

// /user-service/auth/getUserActions

export const getAncWorkSheet = (patientId, visitId) => {
  return apiClient.get(
    `/patientemr/getPatientAncScheduler/${patientId}/${visitId}`,
    {
      headers: authHeader(),
    }
  );
};

export const getAncWorkSheetPrint = (patientId, visitId, patientVisitId) => {
  return apiClient.get(
    `/generatePdf/getANCWorkSheet?patientId=${patientId}&visitId=${visitId}&parentVisitId=${patientVisitId}`,
    {
      headers: authHeader(),
      responseType: "blob",
    }
  );
};

export const getVaccinePrint = (patientId, visitId) => {
  return apiClient.get(
    `/generatePdf/getVaccineChart?patientId=${patientId}&visitId=${visitId}`,
    {
      headers: authHeader(),
      responseType: "blob",
    }
  );
};

export const saveAyurvedaEMRData = async (template, details) => {
  // console.log(departmentId);
  if (template !== undefined) {
    return await apiClient.post(
      `/patientemr/savePatientEmrAyurveda?template=${template}`,
      details,
      {
        headers: authHeader(),
      }
    );
  } else if (template === undefined) {
    return await apiClient.post(`/patientemr/savePatientEmrAyurveda`, details, {
      headers: authHeader(),
    });
  }
};

// service to save ophthalmologyEmr
export const postOphthalmologyEmr = (postObject) => {
  return apiClient.post(`/patientemr/saveEmrOphthalmology`, postObject, {
    headers: authHeader(),
  });
};

// get patientEmr details for patch ( Ophthalmology EMR )
export const getEmrDetailsForOphthalmology = (searchObject) => {
  return apiClient.post(
    `/patientemr/getPatientAssessmentDetails`,
    searchObject,
    {
      headers: authHeader(),
    }
  );
};

